import Vue from 'vue'
import VueRouter from 'vue-router'
import { HEADER_SCROLL_OFFSET, scrollToHash } from '@/utils/navigation'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { title: '首页' }
  },
  {
    path: '/solutions',
    name: 'Solutions',
    component: () => import('@/views/Solutions.vue'),
    meta: { title: '产品定制' }
  },
  {
    path: '/solutions/:id',
    name: 'SolutionDetail',
    component: () => import('@/views/SolutionDetail.vue'),
    meta: { title: '解决方案详情' }
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/News.vue'),
    meta: { title: '新闻资讯' }
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: () => import('@/views/NewsDetail.vue'),
    meta: { title: '新闻详情' }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue'),
    meta: { title: '关于我们' }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/Contact.vue'),
    meta: { title: '联系我们' }
  },
  {
    path: '/cases/:id',
    name: 'CaseDetail',
    component: () => import('@/views/CaseDetail.vue'),
    meta: { title: '客户案例' }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('@/views/admin/NewsAdmin.vue'),
    meta: { title: '新闻管理' }
  }
]

const router = new VueRouter({
  // hash 模式：安企 CMS / 静态托管刷新深链不会 404（history 需服务端回退 index.html）
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) {
      return scrollToHash(to.hash, {
        offset: HEADER_SCROLL_OFFSET,
        behavior: 'auto',
        maxAttempts: 30,
        interval: 100
      }).then(() => false)
    }
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const baseTitle = '元码科技'
  document.title = to.meta.title ? `${to.meta.title} - ${baseTitle}` : `${baseTitle} - 企业数字化软件定制开发`
  next()
})

export default router
